import { getEncarteThemeSearchResult } from "../../../../../services/EncarteThemeService";

const BASE_URL = process.env.REACT_APP_RESOURCES_BASE_URL;

export default function useFetchThemesByName() {
  const fetchThemesByName = async (token, themeName, page = 0, size = 10) => {
    const url = `${BASE_URL}/encartethemes/search?name=${encodeURIComponent(themeName)}&page=${page}&size=${size}`;
    const res = await fetch(url, {
      headers: { Authorization: token },
    });
    if (!res.ok) throw new Error("Failed to fetch themes by name");
    const json = await res.json();
    return getEncarteThemeSearchResult(token, json);
  };
  return fetchThemesByName;
}
